var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHousekeeping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33004)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18800_33004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4501 23.258C16.1082 22.4648 16.595 21.5441 16.8801 20.5537",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52841 20.6578C8.52841 20.6578 12.1967 21.244 14.1504 15.2082C14.2999 14.7456 14.5391 14.317 14.8544 13.9468C15.1696 13.5767 15.5547 13.2723 15.9876 13.051C16.4205 12.8298 16.8928 12.696 17.3774 12.6572C17.8621 12.6186 18.3496 12.6757 18.8121 12.8255C22.4185 13.9628 21.1983 17.4869 21.1983 17.4869C21.1983 17.4869 20.8675 21.9033 18.7072 23.428C14.2925 23.9582 8.52841 20.6578 8.52841 20.6578Z",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8362 17.4558L14.1689 15.4175",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7423 3.66064C20.7423 3.66064 20.6999 10.3891 18.8121 12.8255",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.3901 17.8133H6.4389C6.08959 17.8133 5.75458 17.6745 5.50759 17.4275C5.26059 17.1805 5.12183 16.8455 5.12183 16.4962V9.91083",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48779 8.59399L10.1979 2.07009C10.4357 1.86883 10.7372 1.75839 11.0488 1.75839C11.3603 1.75839 11.6618 1.86883 11.8996 2.07009L18.2997 7.4859",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6584 2.00839H18.2926V4.64254",
    stroke: "black",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.47168)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18800_33004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.009,
    height: 21.009,
    fill: "white",
    transform: "matrix(-0.996093 0.0883106 0.0883106 0.996093 22.6155 2.74408)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeeping);
export default __webpack_public_path__ + "static/media/housekeeping.9530084fa3f83d2e91bcfb1452155cdb.svg";
export { ForwardRef as ReactComponent };